import { createUploadLink } from 'apollo-upload-client';

import CONFIG from './../config/config.json';

const httpLink = new createUploadLink({
  uri: CONFIG.apolloServer.uri,
  credentials: 'same-origin', //include if different backend domain
  headers: {
    'Apollo-Require-Preflight': 'true',
  },
});

export default httpLink;